import Header from "./Header";
import TextResizer from "./TextResizer";
import { useTranslationSetup } from "./utils/useTranslationSetup.js";
import { SCREENS } from "../src/utils/CommonUtils/screenConstants.js";
import { getFirstNameAndTruncate } from "./utils/helper.js";

const OrfTestScreen = ({
  hideArrow,
  setHideArrow,
  hideSlider,
  setHideSlider,
  audioBlobForAudioPlayer,
  setAudioBlobForAudioPlayer,
  paragraph,
  processedData,
  setProcessedData,
  assessmentId,
  setAssessmentId,
  studentName,
  setStudentName,
  orfResultStatus,
  setOrfResultStatus,
  selectedLaguage,
  setSelectedLaguage,
  saveClicked,
  setSaveClicked,
  isAudioUploading,
  setAudioUploading,
  uploadAudioStatus,
  setUploadAudioStatus,
  setActiveScreen,
}) => {
  const { t } = useTranslationSetup();
  const handleClickOnBackOption = () => {
    setActiveScreen(SCREENS.RENDER_START_READING_SCREEN);
  };

  const firstName = getFirstNameAndTruncate(studentName);

  return (
    <>
      <Header
        heading={t("student_orf_test", {
          firstName: firstName,
        })}
        color="#373737"
        hideArrow={hideArrow}
        handleOnClickBackButton={handleClickOnBackOption}
        isSticky={true}
      />
      <TextResizer
        hideSlider={hideSlider}
        setHideSlider={setHideSlider}
        hideArrow={hideArrow}
        setHideArrow={setHideArrow}
        audioBlobForAudioPlayer={audioBlobForAudioPlayer}
        setAudioBlobForAudioPlayer={setAudioBlobForAudioPlayer}
        paragraph={paragraph}
        processedData={processedData}
        setProcessedData={setProcessedData}
        assessmentId={assessmentId}
        setAssessmentId={setAssessmentId}
        studentName={studentName}
        setStudentName={setStudentName}
        orfResultStatus={orfResultStatus}
        setOrfResultStatus={setOrfResultStatus}
        selectedLaguage={selectedLaguage}
        setSelectedLaguage={setSelectedLaguage}
        saveClicked={saveClicked}
        setSaveClicked={setSaveClicked}
        isAudioUploading={isAudioUploading}
        setAudioUploading={setAudioUploading}
        uploadAudioStatus={uploadAudioStatus}
        setUploadAudioStatus={setUploadAudioStatus}
        setActiveScreen={setActiveScreen}
      />
    </>
  );
};

export default OrfTestScreen;
